






















import { Component, Vue } from "vue-property-decorator";
import AccountingComponent from "../components/AccountingComponent.vue";
import emitter from "@/EventBus";
import AccountingSearchOptions from "@/ui/common/presenters/accounting-search-options";
import { PurchasePayment } from "@/usecases/accounting/purchase";
import { client } from "@/api/request";
import { isNewProject } from "@/preferences";
import { PrintNewOrder } from "@/api/orders/print-api";
import {
  changeStatusAccouting,
  IStatusAccouting
} from "@/api/accounting/status-api";
import PaymentPurchasePage from "@/ui/order/pages/PaymentPurchasePage.vue";
import { cloneDeep } from "lodash";
import BankAccountOption from "../presenters/bank-account-option";
import BankAccount from "@/entities/bank-account";
import SelectOption from "@/common/ui/presenters/select-option";
import { StateChanger } from "vue-infinite-loading";
import { format } from "date-fns";

export interface IBankAccount extends BankAccount {
  id: string | number;
}

@Component({
  components: {
    AccountingComponent,
    PaymentPurchasePage
  },
  methods: {
    isNewProject
  }
})
export default class AccountingPurchase extends Vue {
  purchaseSearch = {};
  purchaseItems: PurchasePayment[] = [];
  bankAccounts: SelectOption[] = [];
  isPositionPrinting: number = -1;
  isSearching: boolean = false;

  fields = [
    { key: "estimateNumber", label: "見積書No" },
    { key: "purchaseNumber", label: "発注書No" },
    { key: "dateOfIssue", label: "発行日" },
    { key: "projectName", label: "現場" },
    { key: "title", label: "件名" },
    { key: "vendorName", label: "発注先" },
    { key: "status", label: "ステータス" },
    { key: "lossTotal", label: "金額" },
    {
      key: "actions",
      label: "",
      thStyle: { width: "100px" },
      tdStyle: { width: "100px" }
    }
  ];
  purchase: any = "";

  created() {
    emitter.on("initData", data => {
      this.purchaseSearch = data as AccountingSearchOptions;
    });
    this.initBankAccounts();
  }

  currentOptions(currentLength: number, options?: { projectName: string }) {
    const new_options = {
      ...options,
      purchaseCount: currentLength
    };

    return new_options;
  }

  async getPurchaseList30(options?: any) {
    const new_options = this.currentOptions(this.purchaseItems.length, options);
    const newPurchaseItems = await client.get("get_purchase.php", new_options);

    return newPurchaseItems;
  }

  async loadInfinite($state: StateChanger) {
    const loadedPurchaseItems = await this.getPurchaseList30(
      this.purchaseSearch
    );

    if (loadedPurchaseItems.purchases.length) {
      this.purchaseItems = this.purchaseItems.concat(
        loadedPurchaseItems.purchases
      );

      $state.loaded();
    } else {
      $state.complete();
    }

    if (loadedPurchaseItems.purchases.length < 30) {
      $state.complete();
      return;
    }
  }

  async changeStatus(item: PurchasePayment, status: string) {
    const option: IStatusAccouting = {
      id: item.id,
      projectId: item.projectId,
      status,
      model: "Purchase"
    };
    try {
      const id = await changeStatusAccouting(option);
      this.updatePurchase(id, { status });
    } catch (error) {
      alert(error[0] || error);
    }
  }

  async handleCreatePdf(item: PurchasePayment, index: number) {
    if (this.isPositionPrinting !== -1) {
      alert(
        "現在他の見積書で印刷を生成中です。時間をおいてからもう一度試してください。"
      );

      return;
    }
    this.isPositionPrinting = index;
    let options: PrintNewOrder = {
      id: item.id,
      accessToken: this.$store.state.accessToken,
      printsExcludeTax: item.printsExcludeTax
    };

    if (isNewProject(item.projectCreated)) {
      options = {
        ...options,
        orderNew: 1
      };
    }

    try {
      const data = await client.get("create_purchase_pdf.php", options);
      window.open(data.pdf, "発注書印刷");
    } catch (error) {
      alert(error);
    } finally {
      this.isPositionPrinting = -1;
    }
  }

  async handleShowModal(purchase: PurchasePayment) {
    if (!purchase.bankAccountId && this.bankAccounts.length) {
      purchase.bankAccountId = +this.bankAccounts[0].value;
    }
    if (!purchase.paymentDate) {
      purchase.paymentDate = format(new Date(), "yyyy-MM-dd");
    }
    this.purchase = cloneDeep(purchase);
    this.$nextTick(() => {
      (this.$refs.paymentModal as any).show();
    });
  }

  async savePurchase(purchase: PurchasePayment) {
    const {
      status,
      note,
      amountReceived,
      paymentDate,
      bankAccountId,
      orderedDate
    } = purchase;
    const data = {
      id: purchase.id,
      status,
      note,
      amount_received: amountReceived,
      payment_date: paymentDate,
      bank_account_id: bankAccountId,
      ordered_date: orderedDate,
      type: "Purchase"
    };

    try {
      const res = await client.post("save_payment_info.php", data);
      this.updatePurchase(res.id, {
        status,
        note,
        amountReceived,
        paymentDate,
        bankAccountId,
        orderedDate
      });
      (this.$refs.paymentModal as any).hide();
    } catch (error) {
      alert(error[0] || error);
    }
  }

  updatePurchase(id: number, data: any) {
    const index = this.purchaseItems.findIndex(item => item.id == id);
    if (index !== -1) {
      Vue.set(this.purchaseItems, index, {
        ...this.purchaseItems[index],
        ...data
      });
    }
  }

  async initBankAccounts() {
    const data: IBankAccount[] = await client.get("get_bank_account.php", {
      getAllBanks: true
    });
    this.bankAccounts = data.map(bank => {
      return {
        value: String(bank.id),
        text: new BankAccountOption(bank).value
      };
    });
  }

  async handleSearch($state: StateChanger) {
    this.purchaseItems = [];
    $state.reset();
  }
}
